import React, { useState, useEffect, useContext } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Question from "./Question";
import { Moment } from "moment";
import { useSimpleCountdown } from "../../hooks/useSimpleCountdown";
import { ROUND_TIMEOUT, MAX_QUESTION_SCORE, MAX_PLAYERS } from "../../config";
import { useLocalAnswerStorage } from "../../hooks/useLocalAnswerStorage";
import { GameContext } from "../GameContext";
import { PlayerContext } from "../CurrentPlayerContext";
import { RoundHeader } from "./RoundHeader";
import moment from "moment";
import { clampScore, clamp } from "../../utils";

export const Round = ({
  round,
  questionData,
  answerEnd,
  totalRounds
}: {
  round: number;
  questionData: any;
  totalRounds: number;
  answerEnd: Moment;
}) => {
  const game = useContext(GameContext);
  const [answerable, setAnswerable] = useState(true);
  const [player, { addScore }] = useContext(PlayerContext);
  const seconds = useSimpleCountdown(answerEnd, () => setAnswerable(false));
  const [answer, saveAnswer] = useLocalAnswerStorage(game.id, round);
  const isAnswered = answer ? true : false;
  const [questionScore, setQuestionScore] = useState(0);

  const getScore = () => {
    const ROUND_LENGTH = ROUND_TIMEOUT * 1000;
    const PERC_REM = 1 - answerEnd.diff(moment(), "ms") / ROUND_LENGTH;
    const points = MAX_QUESTION_SCORE - 1000 * PERC_REM;
    return clampScore(Math.round(points));
  };

  const calculateScore = (answer: string) => {
    const a = questionData.answers.find((a: any) => a.text === answer);
    const correct = a && a.isCorrect;
    return correct ? getScore() : 0;
  };

  const scoreAnswer = (guess: string) => {
    if (answerable && !answer) {
      saveAnswer(guess);
      const score = calculateScore(guess);
      setQuestionScore(score);
      addScore(score);
    }
  };

  useEffect(() => {
    setAnswerable(true);
  }, [round]);

  const pointsRemaining = getScore();
  return (
    <AnimatePresence>
      <div className="question-inner">
        <RoundHeader
          currentRound={round}
          playerScore={player.score}
          timeLeft={seconds}
          totalRounds={totalRounds}
        />
        <Question
          questionNumber={round}
          roundData={questionData}
          timeLeft={seconds > 0 ? seconds : 0}
          isAnswered={isAnswered}
          scoreAnswer={scoreAnswer}
          playerAnswer={answer}
          questionScore={questionScore}
          pointsRemaining={pointsRemaining}
          getScore={getScore}
        ></Question>
      </div>
    </AnimatePresence>
  );
};
